<script>
    // @ts-nocheck
    import Modal from '$lib/components/UI/ModalX.svelte'
    import {
        currencyFormatter,
        getDateObj,
        getRelTime,
        validarCuit,
        validarNoNull,
        validarImporte,
        validarDocPDF,
    } from '$lib/utils'
    import dictionaries from '$lib/stores/dictionaries'
    import LoadInvoiceSin from '$lib/custom/components/LoadInvoiceSin.svelte'
    import user from '../../stores/user'
    import PerceptionsTable from '$lib/custom/components/PerceptionsTable.svelte'
    import {
        Row,
        Button,
        Column,
        InputText,
        Typography,
        Select,
    } from '$lib/components/UI'
    import SelectX from '$lib/components/UI/SelectX.svelte'
    import { API_URL } from '$lib/conf'
    import InputDate from '$lib/components/UI/InputDate.svelte'
    import { createEventDispatcher } from 'svelte'
    import ScrollBox from '$lib/components/UI/ScrollBox.svelte'
    import InputFile from '$lib/components/UI/InputFile.svelte'
    export let data = {}
    export let disabled = false
    export let update = true
    const dispatch = createEventDispatcher()

    data = {
        ...data,
        iva: String(data.iva),
        total: String(data.total),
        subtotal: String(data.subtotal),
        ...(update
            ? {}
            : {
                  tipo_factura: null,
                  letra: null,
              }),
    }
    let originalData = structuredClone(data)
    const currentAccount = user.getCurrentAccount()
    data.cuit = $currentAccount

    const tipos_comprobantes = [
        { l: 'A', value: '001', label: 'FACTURAS A' },
        { l: 'A', value: '003', label: 'NOTAS DE CREDITO A' },
        {
            l: 'A',
            value: '201',
            label: 'FACTURA DE CRÉDITO ELECTRÓNICA MiPyMEs (FCE) A',
        },
        {
            l: 'A',
            value: '203',
            label: 'NOTA DE CREDITO ELECTRÓNICA MiPyMEs (FCE) A',
        },
        { l: 'B', value: '006', label: 'FACTURAS B' },
        { l: 'B', value: '008', label: 'NOTAS DE CREDITO B' },
        {
            l: 'B',
            value: '206',
            label: 'FACTURA DE CRÉDITO ELECTRÓNICA MiPyMEs (FCE) B',
        },
        {
            l: 'B',
            value: '208',
            label: 'NOTA DE CREDITO ELECTRÓNICA MiPyMEs (FCE) B',
        },
        { l: 'C', value: '011', label: 'FACTURAS C' },
        { l: 'C', value: '013', label: 'NOTAS DE CREDITO C' },
        {
            l: 'C',
            value: '211',
            label: 'FACTURA DE CRÉDITO ELECTRÓNICA MiPyMEs (FCE) C',
        },
        {
            l: 'C',
            value: '213',
            label: 'NOTA DE CREDITO ELECTRÓNICA MiPyMEs (FCE) C',
        },
        { l: 'M', value: '051', label: 'FACTURAS M' },
        { l: 'M', value: '053', label: 'NOTAS DE CREDITO M' },
    ]
    const letras = ['A', 'B', 'C', 'M']
    $: tipos_comprobantes_filtered = tipos_comprobantes.filter(
        ({ l }) => l === data.letra
    )
    function onSubmit() {
        dispatch('submit', data)
    }
    function onClose() {
        dispatch('close', data)
    }
    let inputFileValue = []
    $: validations = {
        file: (v) => (update ? true : !!validarDocPDF(inputFileValue)),
        no_factura: (n) => n && /^\d{1,8}$/.test(n),
        punto_venta: (n) => n && /^\d{1,8}$/.test(n),
        letra: validarNoNull,
        tipo_factura: validarNoNull,
        fecha_factura: validarNoNull,
        cae: (n) => n && /^\d{14}$/.test(n),
        vencimiento_cae: (n) =>
            validarNoNull(n) && /^\d{4}-\d{2}-\d{2}$/.test(n),
        cuit_destinatario: validarCuit,
        cuit: validarCuit,
        iva: validarImporte,
        total: validarImporte,
        subtotal: validarImporte,
    }

    $: validationFields = Object.entries(validations)
        .map(([key, validation]) => [key, validation(data[key])])
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})

    $: valid = Object.values(validationFields).every((x) => x === true)

    /**/
    $: if (!update && data) {
        data.file =
            inputFileValue?.length > 0
                ? inputFileValue[0]?.fileId || null
                : null
    }

    $: data.subtotal = Number(
        parseFloat(data.total || '0') -
            parseFloat(data.iva || '0') -
            data.percepcion?.reduce(
                (r, c) => r + parseFloat(c?.monto || '0'),
                0
            )
    ).toFixed(2)

    // $: console.log({ validationFields, data })
    function justNumbersTransform(str) { return typeof str === 'string' ? str.replace(/[^\d]/g, '') : str}
</script>

<Modal
    title={!update ? 'Cargar factura' : 'Completar factura'}
    style="min-width: 750px; width: 90%; height: 80%"
    on:close={onClose}
    scroll
>
    <ScrollBox width="100%" height="100%" alwaysVisible>
        {#if !update}
            <InputFile
                label="Cargar Factura"
                endpoint="{API_URL}/upload"
                errMsg="Por favor cargue un documento en formato PDF"
                validation={validations.file}
                bind:value={inputFileValue}
            />
        {/if}
        <Row>
            <InputText
                required
                maxLength={8}
                validation={validations.no_factura}
                label="Factura Nro"
                {disabled}
                bind:value={data.no_factura}
            />
            <InputText
                required
                maxLength={5}
                validation={validations.punto_venta}
                label="Punto de Venta"
                {disabled}
                bind:value={data.punto_venta}
            />
        </Row>
        <Row>
            <Select
                required
                validation={validations.letra}
                label="Letra"
                options={letras}
                {disabled}
                bind:value={data.letra}
            />
            {#key data.letra}
                <SelectX
                    required
                    validation={validations.tipo_factura}
                    label="Tipo de comprobante"
                    options={tipos_comprobantes_filtered}
                    {disabled}
                    bind:value={data.tipo_factura}
                />
            {/key}
        </Row>
        <Row>
            <InputDate
                required
                validation={validations.fecha_factura}
                label="Fecha de la factura"
                {disabled}
                bind:value={data.fecha_factura}
            />
        </Row>
        <Row>
            <InputText
                required
                maxLength={14}
                validation={validations.cae}
                label="CAE/CAI"
                {disabled}
                bind:value={data.cae}
            />
            <InputDate
                required
                validation={validations.vencimiento_cae}
                label="Fecha de vencimiento CAE"
                {disabled}
                bind:value={data.vencimiento_cae}
            />
        </Row>
        <Row>
            <InputText
                required
                maxLength={11}
                transform={justNumbersTransform}
                validation={s => s && validarCuit(s) && /^\d+$/.test(s)}
                label="CUIT Emisor"
                {disabled}
                bind:value={data.cuit_proveedor}
            />
            <InputText
                required
                maxLength={11}
                transform={justNumbersTransform}
                validation={s => s && validarCuit(s) && /^\d+$/.test(s)}
                label="CUIT Destinatario"
                {disabled}
                bind:value={data.cuit_destinatario}
            />
        </Row>
        <Column
            style="border: 1px var(--color-grey-400) dashed; padding: 15px 25px; border-radius: 9px;"
        >
            <Typography type="label">Percepciones</Typography>
            <PerceptionsTable bind:value={data.percepcion} />
        </Column>
        <Row>
            <InputText
                required
                label="IVA"
                maxLength={15}
                prefix="$"
                {disabled}
                validation={validations.iva}
                bind:value={data.iva}
            />
        </Row>
        <Row>
            <InputText
                required
                label="Total"
                maxLength={15}
                validation={validations.total}
                prefix="$"
                {disabled}
                bind:value={data.total}
            />
            <InputText
                required
                label="Subtotal"
                maxLength={15}
                validation={validations.subtotal}
                prefix="$"
                value={data.subtotal}
            />
        </Row>
    </ScrollBox>
    <svelte:fragment slot="buttonSet">
        <Button
            label={!update ? 'Cargar' : 'Guardar'}
            on:click={onSubmit}
            disabled={!valid || disabled}
        />
    </svelte:fragment>
</Modal>
